const OrderStatus = {
    IN_PROCESS: 0,
    PAID: 1,
    ERROR_PAYMENT: 2,
    CANCELLED: 3,
    RESERVED: 4
}

export default OrderStatus;